import { render } from "./CreatingVehicle.vue?vue&type=template&id=f28173ac"
import script from "./CreatingVehicle.vue?vue&type=script&lang=js"
export * from "./CreatingVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script